<script>
import vue2Dropzone from "vue2-dropzone";
import Multiselect from "vue-multiselect";
import { settingService } from "../../../services";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";
import { success_message } from "../../../Helper/helper";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import config from "../../../config";


/**
 * Starter component
 */
export default {
  components: { vueDropzone: vue2Dropzone, Multiselect, DatePicker },
  data() {
    return {
      config: config,
      checked: true,
      checked1: true,
      checked2: true,
      value1: null,
      system_start_time: null,
      showTimePanel: false,
      showTimePanelend: false,
      setting: [],
      payment: [
        "Cash On Delivery",
        "Both",
        "PAYMENT ONLINE",
        "RESTAURANT SELECT PAYMENT OPTION",
      ],
      errors: "",
      app_signin_page: [{ facebook: "1", google: "1", phone: "1", email: "1" , apple: "1"}],
      setting: {
        item_counts: "",
        min_order_value: "",
        min_order_value_business: "",
        min_order_crates_value: "",
        min_order_crates_value_business: "",
        pickup_order_start_time: "",
        pickup_order_end_time: "",
        restaurant_kilometer: "",
        contact_less_delivery_text: "",
        schedule_order_after_business_hours_text: "",
        schedule_order_after_business_hours_another_lang: "",
      },
    };
  },
  validations: {
    setting: {
      restaurant_kilometer: {
        required,
        numeric,
      },
      min_order_value: {
        required,
        numeric,
      },
      min_order_value_business: {
        required,
        numeric,
      },
      min_order_crates_value: {
        required,
        numeric,
      },
      min_order_crates_value_business: {
        required,
        numeric,
      },
      pickup_order_start_time: {
        required
      },
      pickup_order_end_time: {
        required
      },
      subscription_limit: {
        required,
        numeric,
      },
      order_cancel_limit: {
        required,
        numeric,
      },
      order_update_limit: {
        required,
        numeric,
      },
      item_counts: {
        required,
        numeric,
      },
      contact_less_delivery_text: {
        required: requiredIf(function (form) {
          return this.setting.contact_less_delivery == "1";
        }),
      },
      // schedule_order_after_business_hours_text:{
      //   required: requiredIf(function(form){
      //     return this.setting.is_enable_schedule_order_after_business_hours == '1';
      //   }),
      // },
      not_available_reason: {
        required: requiredIf(function (form) {
          return !this.setting.is_system_available;
        }),
        //  requiredIf:() => !this.setting.is_system_available,
      },
    },
  },
  mounted() {
    this.getSetting();
  },
  methods: {
    getSetting() {
      settingService.getSetting().then((response) => {
        this.setting = response.data.result;
        if (
          this.setting.app_signin_page &&
          this.setting.app_signin_page !== ""
        ) {
          this.app_signin_page = this.setting.app_signin_page;
        }
        this.system_start_time = response.data.result.system_start_time;
      });
    },
    open_system() {
      this.setting.is_system_available = "Yes";
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: "You won't be able to revert this!",
      //   icon: "success",
      //   showCancelButton: true,
      //   confirmButtonColor: "#34c38f",
      //   cancelButtonColor: "#f46a6a",
      //   confirmButtonText: "Ok"
      // }).then(result => {
      //   if (result.value) {
      //     Swal.fire("Ok!", "success");
      //   }
      // });
    },
    close_system() {
      this.setting.is_system_available = "No";
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: "You won't be able to revert this!",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#34c38f",
      //   cancelButtonColor: "#f46a6a",
      //   confirmButtonText: "Ok"
      // }).then(result => {
      //   if (result.value) {
      //     Swal.fire("Deleted!", "Your file has been deleted.", "success");
      //   }
      // });
    },
    getDisabledStartTime(date){
        var rs = false
        if(this.setting.pickup_order_end_time!== '' && !rs){
            if(this.moment(date).isSameOrAfter(this.moment(this.setting.pickup_order_end_time,'H:mm'))){
                rs = true;
            }
        }
        return rs;
    },
    getDisabledEndTime(date){
        var rs = false
        if(this.setting.pickup_order_start_time !== '' && !rs){
            if(this.moment(date).isSameOrBefore(this.moment(this.setting.pickup_order_start_time,'H:mm'))){
                rs = true;
            }
        }
        return rs;
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    toggleTimePanelend() {
      this.showTimePanelend = !this.showTimePanelend;
    },
    handleOpenChangeend() {
      this.showTimePanelend = false;
    },
    generalIt() {
      this.$v.$touch();
      console.log(this.$v.setting.$invalid);
      if (this.$v.setting.$invalid) {
        console.log("if");
        return;
      } else {
        const fd = new FormData();
        fd.append("system_start_time", this.setting.system_start_time);
        fd.append("system_end_time", this.setting.system_end_time);
        fd.append("restaurant_kilometer", this.setting.restaurant_kilometer);
        fd.append("service_tax", this.setting.service_tax);
        fd.append("is_system_available", this.setting.is_system_available);
        fd.append("not_available_reason", this.setting.not_available_reason);
        fd.append(
          "not_available_reason_secondary_lang",
          this.setting.not_available_reason_secondary_lang
        );
        fd.append("included_tax", this.setting.included_tax);
        fd.append("is_pickup_enable", this.setting.is_pickup_enable);
        fd.append("is_same_day_delivery", this.setting.is_same_day_delivery);
        fd.append(
          "is_enable_schedule_order_after_business_hours",
          this.setting.is_enable_schedule_order_after_business_hours
        );
        fd.append(
          "schedule_order_after_business_hours_text",
          this.setting.schedule_order_after_business_hours_text
        );
        fd.append(
          "schedule_order_after_business_hours_another_lang",
          this.setting.schedule_order_after_business_hours_another_lang
        );
        fd.append("min_order_value", this.setting.min_order_value);
        fd.append("min_order_value_business", this.setting.min_order_value_business);
        fd.append("min_order_crates_value", this.setting.min_order_crates_value);
        fd.append("min_order_crates_value_business", this.setting.min_order_crates_value_business);
        fd.append("pickup_order_start_time", this.setting.pickup_order_start_time);
        fd.append("pickup_order_end_time", this.setting.pickup_order_end_time);
        fd.append("subscription_limit", this.setting.subscription_limit);
        fd.append("order_cancel_limit", this.setting.order_cancel_limit);
        fd.append("order_update_limit", this.setting.order_update_limit);
        fd.append(
          "restaurant_payment_option",
          this.setting.restaurant_payment_option
        );
        fd.append(
          "restaurant_service_tax",
          this.setting.restaurant_service_tax
        );
        fd.append("contact_less_delivery", this.setting.contact_less_delivery);
        fd.append(
          "contact_less_delivery_text",
          this.setting.contact_less_delivery_text
        );
        fd.append("payment", this.setting.payment);
        fd.append("item_counts", this.setting.item_counts);
        fd.append("app_signin_page", JSON.stringify(this.app_signin_page));
        fd.append("type", 1);
        settingService.updateSetting(fd).then((response) => {
          if (response.data.code === 200) {
            if (response.data.result) {
              this.$auth.updateSetting(response.data.result.settings);
            }
            success_message(response.data.message);
          } else {
            error_message(response.data.message);
            0;
          }
        });
      }
    },
    floatingNumber(e) {
      const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
      let char = String.fromCharCode(e.keyCode);
      if (floating.test(char)) return true;
      else e.preventDefault();
    },
  },
  
};
</script>
<template>
  <b-form @submit.prevent="generalIt">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body setting-main">
            

            <div class="row section-main">
              <div class="col-md-4">
                <div class="setting-heading">
                  <h4>Application Settings</h4>
                </div>
              </div>
              <div class="col-md-8">
                <div class="setting-data">
        
                  <div class="tax-main">
                    
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6 order-value">
                            <b-form-group
                              id="input-group-1"
                              :label="trans.get('__JSON__.Min Order Value for Private user')"
                              label-for="name"
                            >
                              <b-form-input
                                id="min_order_value"
                                name="min_order_value"
                                v-model="$v.setting.min_order_value.$model"
                                type="text"
                                :placeholder="
                                  trans.get('__JSON__.Min Order Value for Private user')
                                "
                                :class="{
                                  'is-invalid':
                                    $v.setting.min_order_value.$error,
                                }"
                                v-on:keypress="floatingNumber($event,setting.min_order_value)"
                              ></b-form-input>
                              <div
                                v-if="$v.setting.min_order_value.$error"
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.setting.min_order_value.required"
                                  >{{
                                    trans.get("__JSON__.Min Order Value")
                                  }}.</span
                                >
                                <span v-if="!$v.setting.min_order_value.numeric"
                                  >{{
                                    trans.get("__JSON__.Enter Numeric Value")
                                  }}.</span
                                >
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-6 order-value">
                            <b-form-group id="input-group-2" :label="trans.get('__JSON__.Min Order Value for Business user')" label-for="name">
                                <b-form-input
                                  id="min_order_value_business"
                                  name="min_order_value_business"
                                  v-model="$v.setting.min_order_value_business.$model"
                                  type="text"
                                  :placeholder="trans.get('__JSON__.Min Order Value for Business user')"
                                  :class="{ 'is-invalid':  $v.setting.min_order_value_business.$error }"
                                  v-on:keypress="floatingNumber($event,setting.min_order_value_business)"
                                ></b-form-input>
                                <div v-if=" $v.setting.min_order_value_business.$error" class="invalid-feedback">
                                  <span
                                    v-if="!$v.setting.min_order_value_business.required"
                                  >{{ trans.get('__JSON__.Min Order Value') }}.</span>
                                    <span
                                    v-if="!$v.setting.min_order_value_business.numeric"
                                  >{{ trans.get('__JSON__.Enter Numeric Value') }}.</span>
                                </div>
                            </b-form-group> 
                          </div>
                          <div class="col-md-12">
                            <p>
                              {{
                                trans.get(
                                  "__JSON__.Ordering Application will not allow placing an order less than the Minimum order value"
                                )
                              }}.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6 order-value">
                            <b-form-group
                              id="input-group-1"
                              :label="trans.get('__JSON__.Max Order Crates Value for Private user')"
                              label-for="name"
                            >
                              <b-form-input
                                id="min_order_crates_value"
                                name="min_order_crates_value"
                                v-model="$v.setting.min_order_crates_value.$model"
                                type="text"
                                :placeholder="
                                  trans.get('__JSON__.Max Order Crates Value for Private user')
                                "
                                :class="{
                                  'is-invalid':
                                    $v.setting.min_order_crates_value.$error,
                                }"
                                v-on:keypress="floatingNumber($event,setting.min_order_crates_value)"
                              ></b-form-input>
                              <div
                                v-if="$v.setting.min_order_crates_value.$error"
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.setting.min_order_crates_value.required"
                                  >{{
                                    trans.get("__JSON__..Max Order Crates Value for Private user")
                                  }}.</span
                                >
                                <span v-if="!$v.setting.min_order_crates_value.numeric"
                                  >{{
                                    trans.get("__JSON__.Enter Numeric Value")
                                  }}.</span
                                >
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-6 order-value">
                            <b-form-group id="input-group-2" :label="trans.get('__JSON__.Max Order Crates Value for Business user')" label-for="name">
                                <b-form-input
                                  id="min_order_crates_value_business"
                                  name="min_order_crates_value_business"
                                  v-model="$v.setting.min_order_crates_value_business.$model"
                                  type="text"
                                  :placeholder="trans.get('__JSON__.Max Order Crates Value for Business user')"
                                  :class="{ 'is-invalid':  $v.setting.min_order_crates_value_business.$error }"
                                  v-on:keypress="floatingNumber($event,setting.min_order_crates_value_business)"
                                ></b-form-input>
                                <div v-if=" $v.setting.min_order_crates_value_business.$error" class="invalid-feedback">
                                  <span
                                    v-if="!$v.setting.min_order_crates_value_business.required"
                                  >{{ trans.get('__JSON__.Max Order Crates Value for Business user') }}.</span>
                                    <span
                                    v-if="!$v.setting.min_order_crates_value_business.numeric"
                                  >{{ trans.get('__JSON__.Enter Numeric Value') }}.</span>
                                </div>
                            </b-form-group> 
                          </div>
                          <div class="col-md-12">
                            <p>
                              {{
                                trans.get(
                                  "__JSON__.Ordering Application will not allow placing an order less than the Minimum order crates value"
                                )
                              }}.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6 order-value">
                            <label class="required">{{ trans.trans('__JSON__.Pickup order Start time')}}</label>
                              <date-picker
                                v-model="$v.setting.pickup_order_start_time.$model"
                                :time-picker-options="{
                                    start: '00:00',
                                    step: '01:00',
                                    end: '23:00',
                                }"
                                format="H:mm"
                                type="time"
                                class="date-time"
                                placeholder="H:mm"
                                name="pickup_order_start_time"
                                valueType="format"
                                :editable="false"
                                :class="{ 'is-invalid':$v.setting.pickup_order_start_time.$error }"
                                :disabled-time="function(date){return getDisabledStartTime(date)}"
                            ></date-picker>
                            <div v-if="$v.setting.pickup_order_start_time.$error" class="invalid-feedback">
                                <span v-if="!$v.setting.pickup_order_start_time.required">{{ trans.get('__JSON__.Please select start time') }}</span>
                            </div>
                          </div>
                          <div class="col-md-6 order-value">
                            <label class="required">{{ trans.trans('__JSON__.To Time')}}</label>
                            <date-picker
                                v-model="$v.setting.pickup_order_end_time.$model"
                                :time-picker-options="{
                                    start: '00:00',
                                    step: '01:00',
                                    end: '23:00',
                                }"
                                format="H:mm"
                                type="time"
                                class="date-time"
                                placeholder="H:mm"
                                name="pickup_order_end_time"
                                valueType="format"
                                :editable="false"
                                :class="{ 'is-invalid':$v.setting.pickup_order_end_time.$error }"
                                :disabled-time="function(date){return getDisabledEndTime(date)}"
                            ></date-picker>
                            <div v-if="$v.setting.pickup_order_end_time.$error" class="invalid-feedback">
                                <span v-if="!$v.setting.pickup_order_end_time.required">{{ trans.get('__JSON__.Please select to time') }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6 order-value">
                            <b-form-group
                              id="input-group-1"
                              :label="trans.get('__JSON__.Subscription Limit')"
                              label-for="name"
                            >
                              <b-form-input
                                id="subscription_limit"
                                name="subscription_limit"
                                v-model="$v.setting.subscription_limit.$model"
                                type="text"
                                :placeholder="
                                  trans.get('__JSON__.Subscription Limit')
                                "
                                :class="{
                                  'is-invalid':
                                    $v.setting.subscription_limit.$error,
                                }"
                                v-on:keypress="floatingNumber($event,setting.subscription_limit)"
                              ></b-form-input>
                              <div
                                v-if="$v.setting.subscription_limit.$error"
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.setting.subscription_limit.required"
                                  >{{
                                    trans.get("__JSON__.Subscription Limit")
                                  }}.</span
                                >
                                <span v-if="!$v.setting.subscription_limit.numeric"
                                  >{{
                                    trans.get("__JSON__.Enter Numeric Value")
                                  }}.</span
                                >
                              </div>
                            </b-form-group>
                          </div>
                          
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6 order-value">
                            <b-form-group
                              id="input-group-1"
                              :label="trans.get('__JSON__.Order Cancel Time')"
                              label-for="name"
                            >
                              <b-form-input
                                id="order_cancel_limit"
                                name="order_cancel_limit"
                                v-model="$v.setting.order_cancel_limit.$model"
                                type="text"
                                :placeholder="
                                  trans.get('__JSON__.Order Cancel Time')
                                "
                                :class="{
                                  'is-invalid':
                                    $v.setting.order_cancel_limit.$error,
                                }"
                                v-on:keypress="floatingNumber($event,setting.order_cancel_limit)"
                              ></b-form-input>
                              <div
                                v-if="$v.setting.order_cancel_limit.$error"
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.setting.order_cancel_limit.required"
                                  >{{
                                    trans.get("__JSON__.Order Cancel Time")
                                  }}.</span
                                >
                                <span v-if="!$v.setting.order_cancel_limit.numeric"
                                  >{{
                                    trans.get("__JSON__.Enter Numeric Value")
                                  }}.</span
                                >
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6 order-value">
                            <b-form-group
                              id="input-group-1"
                              :label="trans.get('__JSON__.Order Update Time')"
                              label-for="name"
                            >
                              <b-form-input
                                id="order_update_limit"
                                name="order_update_limit"
                                v-model="$v.setting.order_update_limit.$model"
                                type="text"
                                :placeholder="
                                  trans.get('__JSON__.Order Update Time')
                                "
                                :class="{
                                  'is-invalid':
                                    $v.setting.order_update_limit.$error,
                                }"
                                v-on:keypress="floatingNumber($event,setting.order_update_limit)"
                              ></b-form-input>
                              <div
                                v-if="$v.setting.order_update_limit.$error"
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.setting.order_update_limit.required"
                                  >{{
                                    trans.get("__JSON__.Order Update Time")
                                  }}.</span
                                >
                                <span v-if="!$v.setting.order_update_limit.numeric"
                                  >{{
                                    trans.get("__JSON__.Enter Numeric Value")
                                  }}.</span
                                >
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-12">
                            <h6>{{ trans.get("__JSON__.Payment Method") }}</h6>
                          </div>
                          <div class="col-md-6 order-value">
                            <select
                              class="custom-select"
                              v-model="setting.restaurant_payment_option"
                              id="restaurant_payment_option"
                              name="restaurant_payment_option"
                            >
                              <option value="Both">
                                {{ trans.get("__JSON__.Both") }}
                              </option>
                              <option value="COD">
                                {{ trans.get("__JSON__.Cash On Delivery") }}
                              </option>
                              <option value="PAY ONLINE">
                                {{ trans.get("__JSON__.PAY ONLINE") }}
                              </option>
                              <option value="Restaurant Select Payment Option">
                                {{
                                  trans.get(
                                    "__JSON__.RESTAURANT Select Payment Method",
                                    { vendor: $auth.setting.restaurant_name }
                                  )
                                }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-12">
                            <p>
                              {{
                                trans.get(
                                  "__JSON__.Ordering Application will allow selected Payment methods"
                                )
                              }}.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-md-12">
                        <div class="row">
                          <!-- <div class="col-md-12">
                                          <h6>Items Loading Count</h6>
                          </div>-->
                          <div class="col-md-6 order-value">
                            <b-form-group
                              id="input-group-1"
                              :label="
                                trans.get(
                                  '__JSON__.Item Loading Limit for Pagination'
                                )
                              "
                              label-for="name"
                            >
                              <b-form-input
                                id="item_counts"
                                name="item_counts"
                                v-model="$v.setting.item_counts.$model"
                                type="text"
                                :placeholder="
                                  trans.get(
                                    '__JSON__.Item Loading Limit for Pagination'
                                  )
                                "
                                :class="{
                                  'is-invalid': $v.setting.item_counts.$error,
                                }"
                                v-on:keypress="floatingNumber($event,setting.item_counts)"
                              ></b-form-input>
                              <div
                                v-if="$v.setting.item_counts.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.setting.item_counts.required"
                                  >{{
                                    trans.get(
                                      "__JSON__.Item Loading Limit for Pagination"
                                    )
                                  }}.</span
                                >
                                <span v-if="!$v.setting.item_counts.numeric"
                                  >{{
                                    trans.get("__JSON__.Enter Numeric Value")
                                  }}.</span
                                >
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-12">
                            <p>
                              Number of Item Load Same time on
                              {{ $auth.setting.restaurant_name }} Details Page.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row section-main">
              <div class="col-md-4">
                <div class="setting-heading">
                  <h4>{{ trans.get("__JSON__.Application Login Methods") }}</h4>
                 
                </div>
              </div>
              <div class="col-md-8">
                <div
                  class="setting-data"
                  v-for="(v, index) in app_signin_page"
                  :key="index"
                >
                  <div class="row">
                    <div class="col-md-6 mt-1">
                      <h6>{{ trans.get("__JSON__.Facebook") }}</h6>
                    </div>
                    <div class="col-md-6">
                      <div class="swtich-data">
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="facebook"
                              name="facebook"
                              v-model="v.facebook"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mt-1">
                      <h6>{{ trans.get("__JSON__.Google") }}</h6>
                    </div>
                    <div class="col-md-6">
                      <div class="swtich-data">
                        
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="google"
                              name="google"
                              v-model="v.google"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-md-6 mt-1">
                      <h6>{{ trans.get("__JSON__.Phone") }}</h6>
                    </div>
                    <div class="col-md-6">
                      <div class="swtich-data">
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="phone"
                              name="phone"
                              v-model="v.phone"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="row">
                    <div class="col-md-6 mt-1">
                      <h6>{{ trans.get("__JSON__.Apple") }}</h6>
                    </div>
                    <div class="col-md-6">
                      <div class="swtich-data">
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="apple"
                              name="apple"
                              v-model="v.apple"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mt-1">
                      <h6>{{ trans.get("__JSON__.Email") }}</h6>
                    </div>
                    <div class="col-md-6">
                      <div class="swtich-data">
                        <b-form-group>
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="email"
                              name="email"
                              v-model="v.email"
                              class="switch-on"
                              true-value="1"
                              false-value="0"
                            />
                            <div class="slider round">
                              <span class="on">{{
                                trans.get("__JSON__.On")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.Off")
                              }}</span>
                            </div>
                          </label>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-update">
              <div class="col-sm-6">
                <button
                  type="submit"
                  v-if="
                    $auth.hasPermission(config.permissions.configuration_write)
                  "
                  class="btn btn-primary mr-1 mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>